import { memo, useContext, useEffect, useRef, useState } from 'react';

import { Form, Input, InputNumber } from 'antd';

import classnames from 'classnames';

import { EDIT_COMPONENT_TYPE } from '../../constants/common';

import { DragIndexContext, EditableContext } from './index';

const dragActiveStyle = (dragState, id) => {
  const { active, over, direction } = dragState;
  let style = {};

  if (active && active === id) {
    style = { backgroundColor: 'gray', opacity: 0.5 };
  } else if (over && id === over && active !== over) {
    style =
      direction === 'right'
        ? {
            borderRight: '1px dashed gray'
          }
        : {
            borderLeft: '1px dashed gray'
          };
  }

  return style;
};

function TableBodyCell({ editable, editComponentType, children, dataIndex, record, rules, handleSave, ...props }) {
  const dragState = useContext(DragIndexContext);
  const form = useContext(EditableContext);
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (editable) form.setFieldsValue({ [dataIndex]: record[dataIndex] });
    if (editing) inputRef.current?.focus();
  }, [editing]);

  const toggleEdit = () => {
    form.setFieldsValue({ [dataIndex]: record[dataIndex] });
    setEditing(prev => !prev);
  };

  const save = async () => {
    try {
      const values = await form.validateFields();

      if (record[dataIndex] === values[dataIndex]) return;

      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.error('Save failed:', errInfo);
    } finally {
      inputRef.current?.blur();
    }
  };

  const controlAttrs = {
    className: classnames('w-full', { 'no-border-bg': !editing }),
    readOnly: !editing,
    size: 'small',
    onBlur: save,
    onClick: toggleEdit,
    onPressEnter: save
  };

  const componentType = {
    [EDIT_COMPONENT_TYPE.INPUT]: <Input {...controlAttrs} ref={inputRef} />,
    [EDIT_COMPONENT_TYPE.INPUT_NUMBER]: <InputNumber {...controlAttrs} ref={inputRef} changeOnWheel />
  };

  return (
    <td {...props} style={{ ...props.style, ...dragActiveStyle(dragState, props.id) }}>
      {editable ? (
        <Form.Item style={{ margin: 0 }} name={dataIndex} rules={rules}>
          {componentType[editComponentType]}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
}

export default memo(TableBodyCell);
